let localStorage = {
  localConstant: {
    token: 'DEVOP_TOKEN',
    tabs: 'DEVOP_SYS_TABS',
    account: 'DEVOP_ACCOUNT',
    menu: 'DEVOP_MENU',
    userId: 'DEVOP_USERID',
    userInfo: 'DEVOP_USERINFO'
  }
};
export default localStorage
